import { DeviceState, GameMode, InputAction } from '../constants';
import type { InputManager } from '../input/InputManager';
import type { GameWorld } from '../world/GameWorld';

/** 目標点との距離がこれ以下なら停止する（ポインタ静止時のジッタ防止）。 */
const POINTER_FOLLOW_DEADZONE = 0.75;
/** 通常時の自機移動速度。 */
const PLAYER_SPEED_NORMAL = 4;
/** エイムロック中の自機移動速度（低速で狙いを安定させる）。 */
const PLAYER_SPEED_AIM_LOCKED = 3;

export class PlayerSystem {
  update(world: GameWorld, input: InputManager): void {
    // HOTPATH-BEGIN
    const player = world.player;
    if (world.mode !== GameMode.Playing) return;
    if (player.respawnTicks > 0) {
      player.respawnTicks -= 1;
      if (player.respawnTicks <= 0) {
        player.x = 72;
        player.y = 108;
        player.alive = true;
        player.invulnerabilityTicks = 120;
      }
      return;
    }
    if (!player.alive) return;
    if (player.invulnerabilityTicks > 0) player.invulnerabilityTicks -= 1;
    if (player.fireCooldown > 0) player.fireCooldown -= 1;
    if (player.deviceCooldown > 0) player.deviceCooldown -= 1;
    if (player.deviceActiveTicks > 0) player.deviceActiveTicks -= 1;
    if (player.chainTimer > 0) {
      if (world.hasCombatPressure()) player.chainTimer -= 1;
    } else {
      player.chain = 0;
    }
    if (player.scoreBoostTicks > 0) player.scoreBoostTicks -= 1;
    player.aimLocked = input.held[InputAction.AimLock] !== 0;
    const speed = player.aimLocked ? PLAYER_SPEED_AIM_LOCKED : PLAYER_SPEED_NORMAL;
    // ポインタ追従も既存の速度上限に従う（テレポートなし＝キーボードと速度均衡）。
    if (input.pointerMoveActive) {
      const dx = input.pointerX - player.x;
      const dy = input.pointerY - player.y;
      const dist = Math.sqrt(dx * dx + dy * dy);
      if (dist > POINTER_FOLLOW_DEADZONE) {
        const step = Math.min(speed, dist);
        const inv = 1 / dist;
        player.vx = dx * inv * step;
        player.vy = dy * inv * step;
      } else {
        player.vx = 0;
        player.vy = 0;
      }
    } else {
      player.vx = input.moveX * speed;
      player.vy = input.moveY * speed;
    }
    player.x += player.vx;
    player.y += player.vy;
    player.clampToWorld();
    if (input.pressed[InputAction.Formation] !== 0) world.nodes.cycleFormation();
    if (input.pressed[InputAction.NodeDirectionLeft] !== 0) world.nodes.rotateDirection(-1);
    if (input.pressed[InputAction.NodeDirectionRight] !== 0) world.nodes.rotateDirection(1);
    if (input.held[InputAction.Fire] !== 0) world.weapons.firePlayer(world);
    if (input.pressed[InputAction.Device] !== 0 && player.deviceCooldown <= 0) world.weapons.activateDevice(world);
    if (input.pressed[InputAction.Pause] !== 0) world.mode = GameMode.Paused;
    if (player.deviceActiveTicks <= 0 && world.deviceState === DeviceState.Active) world.deviceState = DeviceState.Cooldown;
    // HOTPATH-END
  }
}
